import {
  PriceClassDetailsForEachDate,
  RateConnectionChannelFieldsType,
  RateMultiplierDetailsForEachDate,
  RoomTypeForRateConnection
} from '../../types/rateConnection'
import RenderCheckboxRowCell from './RenderCheckboxRowCell'
import RenderInputRowCell from './RenderInputRowCell'

interface RenderRowValuesProps {
  rowDataPriceClass?: PriceClassDetailsForEachDate[]
  rowDataRateMultiplier?: RateMultiplierDetailsForEachDate[]
  roomTypeIndex: number
  ratePlanIndex: number
  channelIndex: number
  priceClassIndex: number
  rateMultiplierIndex: number
  updatedRateConnectionList: RoomTypeForRateConnection[]
  setUpdatedRateConnectionList: React.Dispatch<
    React.SetStateAction<RoomTypeForRateConnection[]>
  >
  weekendIndexes: number[]
  selectedMenuFieldInChannelRow: RateConnectionChannelFieldsType
}

const RenderRowValues: React.FC<RenderRowValuesProps> = ({
  rowDataPriceClass,
  rowDataRateMultiplier,
  roomTypeIndex,
  ratePlanIndex,
  channelIndex,
  priceClassIndex,
  rateMultiplierIndex,
  updatedRateConnectionList,
  setUpdatedRateConnectionList,
  weekendIndexes,
  selectedMenuFieldInChannelRow
}) => {
  switch (selectedMenuFieldInChannelRow) {
    case 'priceClass':
      return (
        <>
          {rowDataPriceClass?.map((_, cellIndex: number) => (
            <RenderCheckboxRowCell
              key={cellIndex}
              roomTypeIndex={roomTypeIndex}
              ratePlanIndex={ratePlanIndex}
              channelIndex={channelIndex}
              priceClassIndex={priceClassIndex}
              cellIndex={cellIndex}
              updatedRateConnectionList={updatedRateConnectionList}
              setUpdatedRateConnectionList={setUpdatedRateConnectionList}
              weekendIndexes={weekendIndexes}
            />
          ))}
        </>
      )

    case 'rateMultiplier':
      return (
        <>
          {rowDataRateMultiplier?.map((_, cellIndex) => (
            <RenderInputRowCell
              key={cellIndex}
              roomTypeIndex={roomTypeIndex}
              ratePlanIndex={ratePlanIndex}
              channelIndex={channelIndex}
              rateMultiplierIndex={rateMultiplierIndex}
              cellIndex={cellIndex}
              updatedRateConnectionList={updatedRateConnectionList}
              setUpdatedRateConnectionList={setUpdatedRateConnectionList}
              weekendIndexes={weekendIndexes}
            />
          ))}
        </>
      )
  }
}

export default RenderRowValues
